import axios, { AxiosResponse } from 'axios'
import { LocaleMessageObject } from 'vue-i18n'
import { developmentTranslations } from './i18n.develop'
import { PromiseUtils } from '@/shared/util/promise-utils'

class I18nService {
    async getTranslations(languageId: number, locale:string): Promise<LocaleMessageObject> {
        // TODO change url to new endpoint
        const response =
            await PromiseUtils.toCallSecure(
                axios.get<LocaleMessageObject, AxiosResponse<LocaleMessageObject>>(`/i18n/labels/${languageId}`))
        if (response) {
            return (process.env.NODE_ENV === 'development'
                ? { ...response.data, ...developmentTranslations[locale] }
                : response.data)
        }
        return {}
    }
}

export const i18nService = new I18nService()
